import { Routes } from '@angular/router';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { CompanyUserComponent } from './company-user/company-user.component';
import { EquipmentsComponent } from './equipments/equipments.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LayoutComponent } from './layout/layout.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ProcedureComponent } from './procedure/procedure.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SpecialityComponent } from './speciality/speciality.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { SurgeonlistComponent } from './surgeonlist/surgeonlist.component';
import { JournalComponent } from './journal/journal.component';
import { ManageJournalComponent } from './manage-journal/manage-journal.component';
import { ManageContactComponent } from './manage-contact/manage-contact.component';
import { ProfessionalTrainingComponent } from './professional-training/professional-training.component';
import { ImpersonationComponent } from './impersonation/impersonation.component';
import { ManageApprovalComponent } from './manage-approval/manage-approval.component';
import { UserSpecialityComponent } from './user-speciality/user-speciality.component';
import { UserProcedureComponent } from './user-procedure/user-procedure.component';
import { SurgeonProceduresComponent } from './surgeon-procedures/surgeon-procedures.component';
import { ShiftDaytimeComponent } from './shift-daytime/shift-daytime.component';
import { ReleaseSpecialityComponent } from './release-speciality/release-speciality.component';
import { AnalyticsComponent } from './analytics/analytics.component';
import { UserRoleComponent } from './user-role/user-role.component';
import { StatisticsComponent } from './statistics/statistics.component';
import { ProcedureReportComponent } from './procedure-report/procedure-report.component';
import { SurgeonReportComponent } from './surgeon-report/surgeon-report.component';
import { SpecialitiesReportComponent } from './specialities-report/specialities-report.component';
import { UserComponent } from './users/user.component';
import {VerifyAccountComponent} from './verify-account/verify-account.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { SubscriptionUpdateComponent } from './subscription/subscription-update.component';

export const AppRoutes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'sidebar', component: SidebarComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'change-password', component: ChangePasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'verify-account', component: VerifyAccountComponent },
  { path: 'terms-condition', component: TermsConditionComponent },
  {
    path: 'layout',
    component: LayoutComponent,
    children: [
      // { path: '', component: SpecialityComponent },
      { path: 'speciality', component: SpecialityComponent },
      { path: 'procedure', component: ProcedureComponent },
      { path: 'equipment', component: EquipmentsComponent },
      { path: 'surgeonlist', component: SurgeonlistComponent },
      { path: 'journal', component: JournalComponent },
      { path: 'manage-journal', component: ManageJournalComponent },
      { path: 'manage-contact', component: ManageContactComponent },
      { path: 'professional-training', component: ProfessionalTrainingComponent },
      { path: 'impersonation', component: ImpersonationComponent },
      { path: 'reported-images', component: ManageApprovalComponent },
      { path: 'user-speciality', component: UserSpecialityComponent },
      { path: 'user-procedure', component: UserProcedureComponent },
      { path: 'surgeon-procedures', component: SurgeonProceduresComponent },
      { path: 'shift-daytime', component: ShiftDaytimeComponent },
      { path: 'release-speciality', component: ReleaseSpecialityComponent },
      { path: 'analytics', component: AnalyticsComponent },
      { path: 'users-report', component: UserComponent },
      { path: 'user-roles-report', component: UserRoleComponent },
      { path: 'other-statistics-report', component: StatisticsComponent },
      { path: 'speciality-procedure-report', component: ProcedureReportComponent },
      { path: 'surgeon-report', component: SurgeonReportComponent },
      { path: 'speciality-download-report', component: SpecialitiesReportComponent },
      { path: 'subscription', component: SubscriptionComponent },
      { path: 'subscription/edit/:id', component: SubscriptionUpdateComponent },
    ]
  }
];



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/app.routing.ts